import React, { Component } from "react";
import $ from "jquery";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Home from "./components/Home";
import Style from "./App.module.scss";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import WebProject from "./components/WebProject";
import ContactModal from "./components/ContactModal";
import ChatWidget from "./components/ChatWidget";
import { shouldShowContactButton } from "./utils/utm";
import { notifyPortfolioVisit } from "./utils/notifyPortfolioVisit";
import { 
  initializeAnalytics, 
  trackPageView, 
  trackContactModalOpen, 
  trackContactModalClose,
  trackScrollDepth,
  trackError
} from "./utils/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBPOmlpvMaso1mo6115T136gYYs3OgPSQg",
  authDomain: "reactportfolio-cabec.firebaseapp.com",
  projectId: "reactportfolio-cabec",
  storageBucket: "reactportfolio-cabec.appspot.com",
  messagingSenderId: "1057673744343",
  appId: "1:1057673744343:web:b3b128ec470694d2f7c592",
  measurementId: "G-SBEMZ1R6HZ",
};

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      foo: "bar",
      resumeData: {},
      sharedData: {},
      isContactModalOpen: false,
      showContactButton: false,
    };
    this.contactModalOpenTime = null;
    this.scrollDepthTracked = new Set();
  }

  applyPickedLanguage(pickedLanguage, oppositeLangIconId) {
    this.swapCurrentlyActiveLanguage(oppositeLangIconId);
    document.documentElement.lang = pickedLanguage;
    var resumePath =
      document.documentElement.lang === window.$primaryLanguage
        ? `res_primaryLanguage.json`
        : `res_secondaryLanguage.json`;
    this.loadResumeFromPath(resumePath);
  }

  swapCurrentlyActiveLanguage(oppositeLangIconId) {
    var pickedLangIconId =
      oppositeLangIconId === window.$primaryLanguageIconId
        ? window.$secondaryLanguageIconId
        : window.$primaryLanguageIconId;
  }

  async componentDidMount() {
    this.loadSharedData();
    // Check if contact button should be shown
    this.setState({ showContactButton: shouldShowContactButton() });
    this.applyPickedLanguage(
      window.$primaryLanguage,
      window.$secondaryLanguageIconId
    );
    
    // Initialize Firebase and Analytics
    const app = initializeApp(firebaseConfig);
    initializeAnalytics(app);
    
    // Set up error tracking
    this.setupErrorTracking();
    
    // Set up scroll depth tracking
    this.setupScrollTracking();

    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      trackPageView(data);
      notifyPortfolioVisit(data);
    } catch (error) {
      trackError('api_error', 'Failed to fetch location data', 'App');
      notifyPortfolioVisit(null);
    }
  }

  setupErrorTracking = () => {
    window.addEventListener('error', (event) => {
      trackError('javascript_error', event.error?.message || 'Unknown error', 'Global');
    });

    window.addEventListener('unhandledrejection', (event) => {
      trackError('promise_rejection', event.reason?.message || 'Unhandled promise rejection', 'Global');
    });
  };

  setupScrollTracking = () => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset;
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercentage = Math.round((scrollTop / documentHeight) * 100);

          // Track milestones: 25%, 50%, 75%, 90%, 100%
          const milestones = [25, 50, 75, 90, 100];
          
          milestones.forEach(milestone => {
            if (scrollPercentage >= milestone && !this.scrollDepthTracked.has(milestone)) {
              trackScrollDepth(milestone);
              this.scrollDepthTracked.add(milestone);
            }
          });
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
  };

  loadResumeFromPath(path) {
    $.ajax({
      url: path,
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  }

  loadSharedData() {
    $.ajax({
      url: `portfolio_shared_data.json`,
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ sharedData: data });
        document.title = `${this.state.sharedData.basic_info.name}`;
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  }

  openContactModal = () => {
    this.contactModalOpenTime = Date.now();
    trackContactModalOpen('contact_button');
    this.setState({ isContactModalOpen: true });
  };

  closeContactModal = () => {
    if (this.contactModalOpenTime) {
      const timeSpent = Math.round((Date.now() - this.contactModalOpenTime) / 1000);
      trackContactModalClose(timeSpent);
    }
    this.setState({ isContactModalOpen: false });
  };

  render() {
    return (
      <div className="app-container">
        <div className="hero-section">
          <Home />
        </div>
        
        {/*<Header sharedData={this.state.sharedData.basic_info} />*/}
        <About
          resumeBasicInfo={this.state.resumeData.basic_info}
          sharedBasicInfo={this.state.sharedData.basic_info}
        />
        <WebProject
          resumeProjects={this.state.resumeData.web_project}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Projects
          resumeProjects={this.state.resumeData.projects}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Skills
          sharedSkills={this.state.sharedData.skills}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Experience
          resumeExperience={this.state.resumeData.experience}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Footer sharedBasicInfo={this.state.sharedData.basic_info} />

        {/* Contact Button - Show only when UTM source is not upwork */}
        {this.state.showContactButton && (
          <button
            className="contact-button"
            onClick={this.openContactModal}
            aria-label="Let’s Connect"
          >
            Let’s Connect
          </button>
        )}

        {/* Contact Modal */}
        <ContactModal
          isOpen={this.state.isContactModalOpen}
          onRequestClose={this.closeContactModal}
        />

        {/* Local Qwen assistant — only renders when Ollama is reachable */}
        <ChatWidget onOpenContact={this.openContactModal} />
      </div>
    );
  }
}

export default App;
